import React from 'react';
import { useNavigate } from 'react-router-dom';
import PortfolioForm from '../../components/Portfolios/PortfolioForm';

const PortfolioCreate = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div className="page-header">
        <button onClick={() => navigate('/app/portfolios')} className="back-button">
          <i className="fas fa-arrow-left"></i> Back to Portfolios
        </button>
        <h1>Create New Portfolio</h1>
      </div>
      <PortfolioForm />
    </div>
  );
};

export default PortfolioCreate;

